import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    createProduct,
    getCategories,
    createCategory,
    deleteCategory, // ✅ bunu api-də əlavə edəcəksən
} from "../api/menupro.api";
import { uploadToImgBB } from "../api/imgbb";
import { getBusiness } from "../store/menupro.store";
import "./addproduct.css";

export default function AddProduct() {
    const navigate = useNavigate();
    const business = getBusiness();

    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [price, setPrice] = useState("");
    const [image, setImage] = useState(null);

    const [categories, setCategories] = useState([]);
    const [categoryId, setCategoryId] = useState("");

    // modal state
    const [catModalOpen, setCatModalOpen] = useState(false);
    const [newCatName, setNewCatName] = useState("");
    const [catSaving, setCatSaving] = useState(false);
    const [catDeletingId, setCatDeletingId] = useState(null);

    useEffect(() => {
        if (!business?.id) {
            navigate("/menupro/login");
            return;
        }
        loadCategories();
        // eslint-disable-next-line
    }, []);

    const loadCategories = async () => {
        const res = await getCategories(business.id);
        setCategories(res.data || []);
    };

    const openCatModal = () => {
        setNewCatName("");
        setCatModalOpen(true);
    };

    const closeCatModal = () => {
        setCatModalOpen(false);
        setNewCatName("");
    };

    const handleAddCategoryModal = async () => {
        const name = newCatName.trim();
        if (!name) return;

        try {
            setCatSaving(true);

            const res = await createCategory(business.id, { name }); // res.data = new category (id,name)
            const created = res.data;

            // ✅ listə əlavə et (reload etmədən)
            setCategories((prev) => [created, ...prev]);

            // ✅ avtomatik seç
            setCategoryId(String(created.id));

            closeCatModal();
        } catch (e) {
            console.log(e);
            alert("Kateqoriya əlavə olunmadı");
        } finally {
            setCatSaving(false);
        }
    };

    const handleDeleteCategory = async (id) => {
        const ok = window.confirm("Bu kateqoriyanı silmək istəyirsən?");
        if (!ok) return;

        try {
            setCatDeletingId(id);
            await deleteCategory(id);

            setCategories((prev) => prev.filter((c) => c.id !== id));

            // silinən kateqoriya seçilidirsə reset et
            if (String(categoryId) === String(id)) {
                setCategoryId("");
            }
        } catch (e) {
            console.log(e);
            alert("Kateqoriya silinmədi (bəlkə içində məhsul var?)");
        } finally {
            setCatDeletingId(null);
        }
    };

    const canSubmit = useMemo(() => {
        if (!title.trim()) return false;

        const numPrice = Number(price);
        if (!Number.isFinite(numPrice) || numPrice < 0) return false;

        if (!categoryId) return false;
        if (!image) return false;
        return true;
    }, [title, price, categoryId, image]);

    const handleSubmit = async () => {
        if (!canSubmit) {
            alert("Zəhmət olmasa başlıq, qiymət, kateqoriya və şəkil seçin.");
            return;
        }

        const numPrice = Number(price);
        if (!Number.isFinite(numPrice) || numPrice < 0) {
            alert("Qiymət mənfi ola bilməz");
            return;
        }

        try {
            const imgUrl = await uploadToImgBB(image);

            await createProduct(business.id, {
                title: title.trim(),
                description: description.trim(),
                price: numPrice,
                image: imgUrl,
                categoryId: String(categoryId),
            });

            alert("Məhsul əlavə edildi");
            navigate("/menupro/dashboard");
        } catch (e) {
            console.log(e);
            alert("Xəta baş verdi");
        }
    };

    return (
        <div className="add-container">
            <div className="add-card">
                <h2 className="add-title">Məhsul əlavə et</h2>

                <div className="add-field">
                    <label>Başlıq</label>
                    <input
                        className="add-input"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        placeholder="Məs: Chicken Burger"
                    />
                </div>

                <div className="add-field">
                    <label>Açıqlama</label>
                    <textarea
                        className="add-textarea"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        placeholder="Qısa açıqlama..."
                    />
                </div>

                <div className="add-field">
                    <label>Qiymət</label>
                    <input
                        className="add-input"
                        type="number"
                        inputMode="decimal"
                        min="0"
                        step="0.01"
                        value={price}
                        onChange={(e) => {
                            const v = e.target.value;

                            // boş buraxmağa icazə ver
                            if (v === "") return setPrice("");

                            // mənfini blokla
                            if (v.startsWith("-")) return;

                            // yalnız 0+ rəqəm və . icazə
                            if (!/^\d*\.?\d*$/.test(v)) return;

                            setPrice(v);
                        }}
                        placeholder="Məs: 7.50"
                    />

                </div>

                <div className="add-field">
                    <label>Kateqoriya</label>

                    <div className="add-row">
                        <select
                            className="add-select"
                            value={categoryId}
                            onChange={(e) => setCategoryId(e.target.value)}
                        >
                            <option value="">Seç</option>
                            {categories.map((c) => (
                                <option key={c.id} value={c.id}>
                                    {c.name}
                                </option>
                            ))}
                        </select>

                        <button type="button" className="add-newcat" onClick={openCatModal}>
                            + Yeni
                        </button>
                    </div>
                </div>

                <div className="add-field">
                    <label>Şəkil</label>
                    <input
                        className="add-file"
                        type="file"
                        accept="image/*"
                        onChange={(e) => setImage(e.target.files?.[0] || null)}
                    />
                </div>

                <button className="add-submit" onClick={handleSubmit} disabled={!canSubmit}>
                    Əlavə et
                </button>

                {/* ✅ back button below submit */}
                <button className="add-back" onClick={() => navigate("/menupro/dashboard")}>
                    Geri qayıt
                </button>
            </div>

            {/* ✅ MODAL */}
            {catModalOpen && (
                <div className="mp-modal-overlay" onMouseDown={closeCatModal}>
                    <div className="mp-modal" onMouseDown={(e) => e.stopPropagation()}>
                        <div className="mp-modal-title">Kateqoriya idarəetmə</div>

                        <div className="mp-modal-row">
                            <input
                                className="mp-modal-input"
                                placeholder="Yeni kateqoriya adı"
                                value={newCatName}
                                onChange={(e) => setNewCatName(e.target.value)}
                            />
                            <button
                                className="mp-modal-add"
                                onClick={handleAddCategoryModal}
                                disabled={catSaving || !newCatName.trim()}
                            >
                                {catSaving ? "..." : "Əlavə et"}
                            </button>
                        </div>

                        <div className="mp-modal-list">
                            {categories.length === 0 && (
                                <div className="mp-modal-empty">Hələ kateqoriya yoxdur.</div>
                            )}

                            {categories.map((c) => (
                                <div key={c.id} className="mp-modal-item">
                                    <div className="mp-modal-name">{c.name}</div>
                                    <button
                                        className="mp-modal-del"
                                        onClick={() => handleDeleteCategory(c.id)}
                                        disabled={catDeletingId === c.id}
                                        title="Sil"
                                    >
                                        {catDeletingId === c.id ? "..." : "Sil"}
                                    </button>
                                </div>
                            ))}
                        </div>

                        <button className="mp-modal-close" onClick={closeCatModal}>
                            Bağla
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}

